/*eslint-disable*/

/*
This file is auto-generated by svg-list
https://github.com/psoaresbj/svg-list
*/

const ui = {
  arrowDown: {
    viewbox: '0 0 32 32',
    paths: [
      'M16 10c.6 0 1 .4 1 1v7.7l3.3-3.3c.4-.4 1-.4 1.4 0 .2.2.3.5.3.7 0 .3-.1.5-.3.7l-4.9 4.9c-.2.2-.4.3-.7.3h-.2c-.3 0-.5-.1-.7-.3l-4.9-5c-.4-.4-.4-1 0-1.4.4-.4 1-.4 1.4 0l3.3 3.3V11c0-.6.4-1 1-1z',
    ],
  },
  arrowLeft: {
    viewbox: '0 0 32 32',
    paths: [
      'M22 16c0 .6-.4 1-1 1h-7.7l3.3 3.3c.4.4.4 1 0 1.4-.2.2-.5.3-.7.3-.3 0-.5-.1-.7-.3l-4.9-4.9c-.2-.2-.3-.4-.3-.7v-.2c0-.3.1-.5.3-.7l5-4.9c.4-.4 1-.4 1.4 0 .4.4.4 1 0 1.4L13.3 15H21c.6 0 1 .4 1 1z',
    ],
  },
  arrowRight: {
    viewbox: '0 0 32 32',
    paths: [
      'M10 16c0-.6.4-1 1-1h7.7l-3.3-3.3c-.4-.4-.4-1 0-1.4.2-.2.5-.3.7-.3.3 0 .5.1.7.3l4.9 4.9c.2.2.3.4.3.7v.2c0 .3-.1.5-.3.7l-5 4.9c-.4.4-1 .4-1.4 0-.4-.4-.4-1 0-1.4l3.3-3.3H11c-.6 0-1-.4-1-1z',
    ],
  },
  arrowUp: {
    viewbox: '0 0 32 32',
    paths: [
      'M16 22c-.6 0-1-.4-1-1v-7.7l-3.3 3.3c-.4.4-1 .4-1.4 0-.2-.2-.3-.5-.3-.7 0-.3.1-.5.3-.7l4.9-4.9c.2-.2.4-.3.7-.3h.2c.3 0 .5.1.7.3l4.9 5c.4.4.4 1 0 1.4-.4.4-1 .4-1.4 0L17 13.3V21c0 .6-.4 1-1 1z',
    ],
  },
  close: {
    viewbox: '0 0 32 32',
    paths: [
      'M22.7 21.3c.4.4.4 1 0 1.4-.2.2-.4.3-.7.3s-.5-.1-.7-.3L16 17.4l-5.3 5.3c-.2.2-.4.3-.7.3s-.5-.1-.7-.3c-.4-.4-.4-1 0-1.4l5.3-5.3-5.3-5.3c-.4-.4-.4-1 0-1.4s1-.4 1.4 0l5.3 5.3 5.3-5.3c.4-.4 1-.4 1.4 0s.4 1 0 1.4L17.4 16l5.3 5.3z',
    ],
  },
};
export default ui;
